/**
 * @file 微博服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {get} from 'lodash';

export default class WeiboServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'weibo';

    formData = {
        appId: '',
        name: '',
        weiboId: '',
        weiboName: '',
        submitType: null
    };

    adaptData(data) {
        data = super.adaptData(data);
        return {
            ...data,
            weiboId: get(this.serviceDetail.serviceData, 'realWeiboId', ''),
            weiboName: get(this.serviceDetail.data, 'weiboName', '')
        };
    }
}
